import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { Link, useLocation } from 'react-router-dom';
import SportCode from "components/common/SportCode";

import { getSportCodeObject } from "components/common/SportCode";
import useViewport from "components/general/useViewPort";
import Competitor from "components/presentation/Competitor";
import Noc from "components/presentation/Noc";
import { isLiveStatus, isLessLiveStatus, isFinishedStatus } from "helpers/status";
import { useUrlFriendlyToParameters, useGetURL } from "helpers/urlFriendly";

import {
  CompetitorBlockNoData as CompetitorBlockNoDataGeneric
  , CompetitorBlock as CompetitorBlockGeneric
  , CompetitorBlockWinner as CompetitorBlockGenericWinner
  , Footer as FooterGeneric
  , Header as HeaderGeneric
  , CompetitorHeader as CompetitorHeaderGeneric
} from "components/sports/glo/brackets/generic"

// BDM
import { CompetitorBlockNoData as CompetitorBlockNoDataBdm, Footer as FooterBdm, CompetitorBlock as CompetitorBlockBdm } from "components/sports/glo/brackets/bdm";
// BK3
import { CompetitorBlockNoData as CompetitorBlockNoDataBk3, Footer as FooterBk3, Header as HeaderBk3 } from "components/sports/glo/brackets/bk3";
// BKB
import { CompetitorBlockNoData as CompetitorBlockNoDataBkb } from "components/sports/glo/brackets/bkb";
// BOX 
import { Footer as FooterBox, CompetitorBlockNoData as CompetitorBlockNoDataBox } from "components/sports/glo/brackets/box";
// CLB
import { Header as HeaderClb, CompetitorBlockNoData as CompetitorBlockNoDataClb, CompetitorBlock as CompetitorBlockClb } from "components/sports/glo/brackets/clb"
// CSL
import { CompetitorBlock as CompetitorBlockCSL, Header as HeaderCSL, CompetitorHeader as CompetitorHeaderCSL } from "components/sports/glo/brackets/csl"
// FBL
import { Footer as FooterFbl, CompetitorBlockNoData as CompetitorBlockNoDataFbl } from "components/sports/glo/brackets/fbl";
// FEN
import { CompetitorBlockNoData as CompetitorBlockNoDataFen, Footer as FooterFen, CompetitorBlock as CompetitorBlockFen } from "components/sports/glo/brackets/fen"
// HBL
import { CompetitorBlock as CompetitorBlockHbl } from "components/sports/glo/brackets/hbl";
// HOC
import { CompetitorBlockNoData as CompetitorBlockNoDataHoc } from "components/sports/glo/brackets/hoc";
// KIK 
import { Footer as FooterKik, CompetitorBlockNoData as CompetitorBlockNoDataKik } from "components/sports/glo/brackets/kik";
// MTI
import { Footer as FooterMti, CompetitorBlockNoData as CompetitorBlockNoDataMti } from "components/sports/glo/brackets/mti";
// PDL
import { Footer as FooterPdl, CompetitorBlock as CompetitorBlockPdl } from "components/sports/glo/brackets/pdl";
// SRF
import { CompetitorBlock as CompetitorBlockSRF, CompetitorBlockNoData as CompetitorBlockNoDataSRF, Header as HeaderSRF, CompetitorHeader as CompetitorHeaderSRF } from "components/sports/glo/brackets/srf"
// TEN
import { Footer as FooterTen, CompetitorBlock as CompetitorBlockTen } from "components/sports/glo/brackets/ten";
// TEQ
import { CompetitorBlock as CompetitorBlockTeq } from "components/sports/glo/brackets/teq";
// TKW
import { Footer as FooterTkw, CompetitorBlock as CompetitorBlockTkw } from "components/sports/glo/brackets/tkw";
//TTE
import { CompetitorBlock as CompetitorBlockTte, Footer as FooterTte } from "components/sports/glo/brackets/tte";
// VBV
import { Footer as FooterVbv, CompetitorBlock as CompetitorBlockVbv } from "components/sports/glo/brackets/vbv";
// VVO
import { Footer as FooterVvo, CompetitorBlockNoData as CompetitorBlockNoDataVvo } from "components/sports/glo/brackets/vvo";
// WPO
import { Footer as FooterWpo, CompetitorBlockNoData as CompetitorBlockNoDataWpo } from "components/sports/glo/brackets/wpo";
// WRE
import { CompetitorBlock as CompetitorBlockWre } from "components/sports/glo/brackets/wre";


import { Score as ScoreGlobal } from "components/presentation/Score"




/**
 * @description
 * Takes an Array<V>, and a grouping function,
 * and returns a Map of the array grouped by the grouping function.
 *
 * @param list An array of type V.
 * @param keyGetter A Function that takes the the Array type V as an input, and returns a value of type K.
 *                  K is generally intended to be a property key of V.
 *
 * @returns Map of the array grouped by the grouping function.
 */
//export function groupBy<K, V>(list: Array<V>, keyGetter: (input: V) => K): Map<K, Array<V>> {
//    const map = new Map<K, Array<V>>();

/**  How to use Grouped By
const grouped = groupBy(pets, pet => pet.type);

const odd = Symbol();
const even = Symbol();
const numbers = [1, 2, 3, 4, 5, 6, 7];
const oddEven = groupBy(numbers, x => (x % 2 === 1 ? odd : even));
*/

const groupBy = (items, key) => items.reduce(
  (result, item) => ({
    ...result,
    [item[key]]: [
      ...(result[item[key]] || []),
      item,
    ],
  }),
  {},
);


/**
 * Show Barcket Area (Context).
 * - top: Show path  from math located on top
 * - botton: path  from math located on bottom.
 * - center: Show path  from math located on front.
 * - hidden: Hide macth.
 * @param {Object} props        - Object with expecific values
 * @param {string} props.top    - Show path  from math located on top.
 * @param {string} props.botton - Show path  from math located on bottom.
 * @param {string} props.center - Show path  from math located on front.
 * @param {string} props.hidden - Hide macth.
*/



export const ITEM_POSITION = {
  "TOP": 1,
  "BOTTOM": 2,
  "CENTER": 3,
  "NONE": 4,
  "HIDE": 5
};

export const COMPONENT = {
  "BRACKET": 1,
  "LINE": 2,
};

/**
 * Get Class draw line after bracket
 *  
 *  Line has two parts:   
 * 
 *  first part: Line horizontal and line vertical
 * 
 *  second part: Line horizontal 
 * 
 *  Values acpted: 
 * - 1- top: Show path  from math located on top
 * - 2- botton: path  from math located on bottom.
 * - 3- center: Show path  from math located on front.
 * - 4- hidden: Hide macth.
 * @param {numeric} type        - Integer
*/

function getClassType(type) {
  let classType = ''
  let classLineAfter = ''

  switch (type) {
    case ITEM_POSITION.TOP://Top
      classType = 'line-top'
      classLineAfter = 'line-h-top'
      break;
    case ITEM_POSITION.BOTTOM://botton
      classType = 'line-bottom'
      classLineAfter = 'line-h-bottom'
      break;
    case ITEM_POSITION.CENTER://center
      classType = 'line-center'
      classLineAfter = 'line-h-center'
      break;
    case ITEM_POSITION.NONE://center
      classType = ''
      classLineAfter = ''
      break;
    case ITEM_POSITION.HIDE://hide
      classType = 'invisible'
      break;


    default:
    // code block
  }
  return { classType, classLineAfter }
}



function ConditionalLink({ children, condition, ...props }) {
  return !!condition && props.to ? <Link {...props}>{children}</Link> : <>{children}</>
}


const BraketMatchNoMemo = ({ type, data, bracket, phase }) => {
  const { mirs_discipline } = useUrlFriendlyToParameters()
  let params = useUrlFriendlyToParameters();
  //Copy object in order to change 
  let paramsURL = { ...params }
  const classObj = getClassType(type);
  const showIRM = data?.bracketCompetitors && data?.bracketCompetitors.some(item => item?.cp_irm);

  //    dateFormat(dateTime, '', 'HH:mm')
  const CompetitorComponent = getCompetitorType(mirs_discipline)
  const CompetitorNoDataComponent = getCompetitorNoDataType(mirs_discipline)
  const FooterComponent = getFooterType(mirs_discipline)
  const HeaderComponent = getHeaderType(mirs_discipline)
  const CompetitorHeaderComponent = getHeaderCompetitorType(mirs_discipline)

  const rsc = data?.eventUnit?.code;
  //Change parameters URL
  paramsURL["mirs_rsc"] = rsc;
  const url = useGetURL(paramsURL, 'results');
  const hasUrl = rsc ? true : false;

  let classFooter = 'invisible';
  let isLive = isLiveStatus(data?.result?.status?.code);
  let isLessLive = isLessLiveStatus(data?.result?.status?.code);
  let arrDisciplineNoFinished = ['VBV', 'FBL', 'FBB', 'HBL']
  if (data?.code !== 'CLEAN' && (isLive || (data?.bi_date && isLessLive) || (arrDisciplineNoFinished.includes(mirs_discipline) && !isFinishedStatus(data?.result?.status?.code)))) {
    classFooter = 'visible'
  } else {
    classFooter = 'invisible'
  }

  const dataScore = Array.isArray(data?.bracketCompetitors) && data?.bracketCompetitors[0]?.resultItem?.resultDataText && JSON.parse(data?.bracketCompetitors[0]?.resultItem?.resultDataText)
  const swPSO = dataScore?.extra?.pso
  const bracketBody = data?.bracketCompetitors
    ?.sort((a, b) => a.cp_pos - b.cp_pos)
    ?.map((competitor, index) => {
      return (
        <ConditionalLink key={`competitor-bracket-${bracket}-${phase}-${rsc}-${index}`} to={url} condition={hasUrl}>
          <div className={`score-line  d-flex flex-row ${competitor?.resultItem?.resultWLT?.includes('W') ? 'fw-bold' : ''} `}>
            {competitor?.participant ? <CompetitorComponent {...competitor} result={data?.result} strike={competitor?.cp_strike_out==='Y'}/> : <CompetitorNoDataComponent {...competitor} data={data} />}
            {/** Results in match */}
            <ScoreGlobal resultJson={competitor?.resultItem?.resultDataText} discipline={mirs_discipline} type='BRACKET'/>
          </div>
        </ConditionalLink>
      )
    })
  let bracketBlock = bracketBody
  if (swPSO) {
    bracketBlock = <><div className="d-flex flex-row">
      <div className="w-90">
        {bracketBody}
      </div>
      <div className="m-auto fw-bold"><SportCode discipline={mirs_discipline} code={'PSO'} entity={'@Period'} abbr={'true'} /></div>
    </div></>
  }
  return (
    <li className={`bracket-match-container ${classObj.classType} `} >
      <div className={classObj.classLineAfter}>
        <Card className={`score-match ${data?.code === 'CLEAN' ? 'd-none d-sm-block' : ''} `}>
          {/**Header Card.Heeader */}
          <HeaderComponent data={data} bracket={bracket} phase={phase} />
          <Card.Body>
            <>
              <CompetitorHeaderComponent data={data} bracket={bracket} phase={phase} />
              {bracketBlock}
            </>
          </Card.Body>
          {<Card.Footer className={classFooter}>
            <FooterComponent data={data} />
          </Card.Footer>
          }
        </Card>
      </div>
    </li>
  );
};
const BraketMatch = React.memo(BraketMatchNoMemo);

function BraketLine({ type }) {
  const classObj = getClassType(type);
  return (
    <li className={`bracket-match-container ${classObj.classType} `} >
      <div className={classObj.classLineAfter}>
        <div className="bracket-match   ">
          <div className="lineHorizontal"></div>
        </div>
      </div>
    </li>
  );
}

const setPhasesVisibles = (direction, numPhases, numPhasesVisibles, currentPhase, setCurrentPhase, setBlockPhases, bracketCode, bracketKey) => {


  if (bracketCode !== bracketKey) return null

  let _numPhasesVisibles = numPhasesVisibles - 1;
  let split = currentPhase;
  let maxSplits = numPhases - numPhasesVisibles + 1

  if (direction === 'left') {
    if ((split - 1) >= 1) { split = split - 1 }
  } else if (direction === 'rigth') {
    if ((split + 1) + _numPhasesVisibles <= numPhases) { split = split + 1 }
  } else {
    if (split - numPhasesVisibles > -1 && numPhasesVisibles > 1) { split = maxSplits }
    if (numPhases < numPhasesVisibles || numPhases === numPhasesVisibles || currentPhase < 1) { split = 1 }
    //if (currentPhase === 0) { split = 99 }
  }
  //workaround
  if (bracketCode !== 'FNL') {
    split = 1
  }

  if (split > 0) {
    let phases = []
    for (let number = split; number <= split + _numPhasesVisibles; number++) {
      phases.push(number)
    }
    setBlockPhases(phases)
    setCurrentPhase(split)
  }
}

function BracketDraw({ dataSportCodes, bracketCode, data, numPhasesVisibles, arrayNumMatchs, bracketKey }) {
  const { breakPoint } = useViewport();
  const { mirs_discipline } = useUrlFriendlyToParameters()
  const numPhases = data.length;
  //local data 
  //const bracketDataMap = data; //Your map data
  const dataPhases = groupBy(data, 'phaseCode');
  //const [currentBracket, setCurrentBracket] = useState('FNL');
  const [currentPhase, setCurrentPhase] = useState(1);

  const [blockPhases, setBlockPhases] = useState([]);
  const location = useLocation(); //get information passed in routers

  //Execute one time after mounted mounted
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  //change tabs brackets
  useEffect(() => {
    //setCurrentBracket(bracketKey)
    setPhasesVisibles('none', numPhases, numPhasesVisibles, -1, setCurrentPhase, setBlockPhases, bracketCode, bracketKey)
  }, [bracketKey])


  //navigation from phases
  useEffect(() => {
    //Change phase inside bracket screen
    if (location?.state?.bracketPosition) {
      let pos = (numPhases - location.state.bracketPosition) + 1;
      setPhasesVisibles('none', numPhases, numPhasesVisibles, pos, setCurrentPhase, setBlockPhases, bracketCode, bracketKey)
    }
  }, [location.state])

  //Execute when  numPhasesVisibles change , queryScreen 
  React.useEffect(() => {
    //Select phase from no bracket screen
    if (location?.state?.bracketPosition) {
      let pos = (numPhases - location.state.bracketPosition) + 1;
      setPhasesVisibles('none', numPhases, numPhasesVisibles, pos, setCurrentPhase, setBlockPhases, bracketCode, bracketKey)
    } else {
      setPhasesVisibles('left', numPhases, numPhasesVisibles, currentPhase, setCurrentPhase, setBlockPhases, bracketCode, bracketKey)
    }
  }, [numPhasesVisibles])


  const showHidePhases = (value) => {
    return blockPhases && blockPhases.includes(value);
  }
  const Navbar = () => {
    const sw = data.length > numPhasesVisibles
    return (
      sw && <nav>
        <button className='btnNavBracket previous' onClick={() => setPhasesVisibles('left', numPhases, numPhasesVisibles, currentPhase, setCurrentPhase, setBlockPhases, bracketCode, bracketKey)}>
          <span className="previous">
            <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.273 15.977L3.29 8 11.273.023l.704.704L4.71 8l7.266 7.273-.704.704z"></path>
            </svg>
          </span>
        </button>
        <button className='btnNavBracket next' onClick={() => setPhasesVisibles('rigth', numPhases, numPhasesVisibles, currentPhase, setCurrentPhase, setBlockPhases, bracketCode, bracketKey)}>
          <span className="next">
            <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.023 15.273L11.29 8 4.023.727l.704-.704L12.71 8l-7.984 7.977-.704-.704z"></path>
            </svg>
          </span>
        </button>
      </nav>
    );

  }

  let showHeaderPhaseList = showPhaseHeader(mirs_discipline, bracketCode)

  return (
    <>
      {showHeaderPhaseList && <Row className="header-bracket-phase-list">
        {Object.keys(dataPhases).map((phaseCode, index) => {
          ///Render your maps
          return (
            showHidePhases(index + 1) &&
            <Col key={`bracketPhase-${bracketCode}-${phaseCode}`}  >
              <div className=""> {getSportCodeObject(dataSportCodes, mirs_discipline, '@BracketItems', phaseCode).description} </div>
            </Col>
          )
        })}
      </Row>}

      <Container className="fluid bracket-container">
        <Navbar phase={'1'} />
        <Row className="bracket-body">
          {/*Iteramos por el objeto  agrupacion de Fases*/}
          {Object.keys(dataPhases).map((key, index) => {
            let inc = 0;
            let phaseOrder = 0;
            return (
              showHidePhases(index + 1) &&
              <Col key={`bracketColumn--${bracketCode}-${key}`} type={`bracketColumn-${key}`} className="bracket-phase">
                <ul className="bracket-phase-list">
                  {/* We have only one elremet in array by phase after filter  Get first elemet of array:- .find(x=>x!==undefined);   */}
                  {dataPhases[key].find(x => x !== undefined).bracketItems
                    .sort((a, b) => a.bi_position - b.bi_position)
                    .map((bracketItem, index) => {
                      ///Render your maps
                      let sc = getSportCodeObject(dataSportCodes, mirs_discipline, '@BracketItems', key)
                      let mt = []
                      inc = inc + 1;

                      if (inc < bracketItem.bi_position) {
                        for (let i = inc; i < bracketItem.bi_position; i++) {
                          inc = i;
                          mt.push(
                            <BraketMatch
                              key={`bracketItem--${bracketCode}-${key}-${inc}`}
                              type={ITEM_POSITION.HIDE}
                              bracket={bracketCode}
                              phase={key} />
                          )
                        }
                        inc = inc + 1
                      }


                      phaseOrder = Number(sc.order);
                      let bracketType = bracketItem.bi_position % 2 === 0 ? ITEM_POSITION.BOTTOM : ITEM_POSITION.TOP
                      bracketType = Number(sc.order) === 1 ? ITEM_POSITION.NONE : bracketType;
                      bracketType = bracketItem?.code === 'CLEAN' ? ITEM_POSITION.HIDE : bracketType
                      let sw = true;
                      if ((breakPoint === 'xs' || breakPoint === 'sm') && bracketItem?.code === 'CLEAN') {
                        //no draw hide matches in bronze 
                        sw = false
                      }
                      return (
                        sw && <React.Fragment key={`bracketItem-${bracketCode}-${key}-${inc}-`}>
                          {mt}<BraketMatch
                            bracket={bracketCode}
                            phase={key}
                            type={bracketType}
                            data={bracketItem} />
                        </React.Fragment>
                      )
                    })/*end  map bracketItems*/
                  }

                  {/* Add elements complete draw */}

                  {(() => {
                    //let numMatchs = arrayNumMatchs ? arrayNumMatchs[index] : Math.pow(2, phaseOrder - 1);
                    //dataPhases it's mot an array 
                    let phaseNumMatch = Object.keys(dataPhases).length - (index + 1);
                    let numMatchs = arrayNumMatchs ? arrayNumMatchs[index] : Math.pow(2, phaseNumMatch);
                    let emptyMatches = [];
                    for (let i = inc + 1; i <= numMatchs; i++) {
                      emptyMatches.push(
                        <BraketMatch
                          key={`bracketItem--${bracketCode}-${key}-${i}`}
                          type={ITEM_POSITION.HIDE}
                          bracket={bracketCode}
                          phase={key} />
                      );
                    }
                    return emptyMatches;
                  })()}
                </ul>
              </Col>
            )
          })}

        </Row>
      </Container>
    </>
  );
}

export function getCompetitorType(discipline) {
  switch (discipline) {
    case 'BDM':
      return CompetitorBlockBdm
    case 'BKG':
      return CompetitorBlockGenericWinner
    case 'CLB':
      return CompetitorBlockClb
    case 'CSL':
      return CompetitorBlockCSL
    case 'FEN':
      return CompetitorBlockFen
    case 'HBL':
      return CompetitorBlockHbl
    case 'PDL':
      return CompetitorBlockPdl
    case 'SRF':
      return CompetitorBlockSRF
    case 'TEQ':
      return CompetitorBlockTeq
    case 'TEN':
      return CompetitorBlockTen
    case 'TKW':
      return CompetitorBlockTkw
    case 'TTE':
      return CompetitorBlockTte
    case 'VBV':
      return CompetitorBlockVbv
    case 'WPO':
      return CompetitorBlockGenericWinner
    case 'WRE':
      return CompetitorBlockWre
    default: //BKB, JUD
      return CompetitorBlockGeneric
  }
}

export function getCompetitorNoDataType(discipline) {
	switch (discipline) {
		case 'BDM':
			return CompetitorBlockNoDataBdm
		case 'BK3':
		case 'MTI':
			return CompetitorBlockNoDataMti
		case 'KIK':
			return CompetitorBlockNoDataKik
		case 'BOX':
			return CompetitorBlockNoDataBox
		case 'CLB':
			return CompetitorBlockNoDataClb
    case 'RU7':
    case 'WRU':
			return CompetitorBlockNoDataBk3
		case 'WBK':
		case 'BKB':
			return CompetitorBlockNoDataBkb
		case 'FBB':
		case 'GBL':
		case 'FBL':
		case 'HBL':
			return CompetitorBlockNoDataFbl
		case 'FEN':
			return CompetitorBlockNoDataFen
		case 'HOC':
			return CompetitorBlockNoDataHoc
    case 'SRF':
			return CompetitorBlockNoDataSRF
		case 'VBS':
		case 'VVO':
			return CompetitorBlockNoDataVvo
		case 'WPO':
			return CompetitorBlockNoDataWpo
		default://JUD
			return CompetitorBlockNoDataGeneric
	}
}

function getHeaderType(discipline) {
  switch (discipline) {
    case 'SRF':
      return HeaderSRF
    case 'CLB':
      return HeaderClb
    case 'CSL':
      return HeaderCSL
    case 'BK3':
      return HeaderBk3
    default:
      return HeaderGeneric
    // code block
  }
}

function getFooterType(discipline) {
  switch (discipline) {
    case 'FEN':
      return FooterFen
    case 'BK3':
      return FooterBk3
    case 'BDM':
      return FooterBdm
    case 'FBB':
    case 'GBL':
    case 'FBL':
    case 'HBL':
      return FooterFbl
    case 'PDL':
      return FooterPdl
    case 'TEN':
      return FooterTen
    case 'TKW':
      return FooterTkw
    case 'TTE':
      return FooterTte
    case 'VBS':
    case 'VVO':
      return FooterVvo
    case 'VBV':
      return FooterVbv
    case 'BOX':
      return FooterBox
    case 'KIK':
      return FooterKik
    case 'MTI':
      return FooterMti
    case 'WPO':
      return FooterWpo
    default:
      return FooterGeneric
    // code block
  }
}

function getHeaderCompetitorType(discipline) {
  switch (discipline) {
    case 'CSL':
      return CompetitorHeaderCSL
    case 'SRF':
      return CompetitorHeaderSRF
    default:
      return CompetitorHeaderGeneric
  }
}

function showPhaseHeader(discipline, bracketCode) {
  switch (discipline) {
    case 'WPO':
    case 'FBB':
    case 'RU7':
    case 'VBS':
    case 'WRU':
    case 'WBK':
      return bracketCode !== 'FNL' ? false : true
    default: //BKB, JUD
      return true
    // code block
  }
}


export default BracketDraw



function PreviaData(competitor) {
  return (
    <div className='score-competitor-container  d-flex flex-row justify-content-start'>
      <div className='score-uniform score-uniform-home'></div>
      <div className='score-noc'>
        <Noc className='me-1' {...competitor?.participant?.organisation} />
      </div>
      <div className='score-name'><Competitor {...competitor?.participant} hidePicture={true} /> </div>
    </div>
  )
}

const getBracketData = () => {

  const data = [

    { phaseCode: 'FNL1', position: 1, type: ITEM_POSITION.TOP, component: COMPONENT.BRACKET },
    { phaseCode: 'FNL1', position: 2, type: ITEM_POSITION.BOTTOM, component: COMPONENT.BRACKET },
    { phaseCode: 'FNL1', position: 3, type: ITEM_POSITION.TOP, component: COMPONENT.BRACKET },
    { phaseCode: 'FNL1', position: 4, type: ITEM_POSITION.BOTTOM, component: COMPONENT.BRACKET },
    { phaseCode: 'FNL1', position: 5, type: ITEM_POSITION.TOP, component: COMPONENT.BRACKET },
    { phaseCode: 'FNL1', position: 6, type: ITEM_POSITION.BOTTOM, component: COMPONENT.BRACKET },
    { phaseCode: 'FNL1', position: 7, type: ITEM_POSITION.TOP, component: COMPONENT.BRACKET },
    { phaseCode: 'FNL1', position: 8, type: ITEM_POSITION.BOTTOM, component: COMPONENT.BRACKET },
    { phaseCode: 'FNL1', position: 9, type: ITEM_POSITION.TOP, component: COMPONENT.BRACKET },
    { phaseCode: 'FNL1', position: 10, type: ITEM_POSITION.BOTTOM, component: COMPONENT.BRACKET },
    { phaseCode: 'FNL1', position: 11, type: ITEM_POSITION.TOP, component: COMPONENT.BRACKET },
    { phaseCode: 'FNL1', position: 12, type: ITEM_POSITION.BOTTOM, component: COMPONENT.BRACKET },
    { phaseCode: 'FNL1', position: 13, type: ITEM_POSITION.TOP, component: COMPONENT.BRACKET },
    { phaseCode: 'FNL1', position: 14, type: ITEM_POSITION.BOTTOM, component: COMPONENT.BRACKET },
    { phaseCode: 'FNL1', position: 15, type: ITEM_POSITION.TOP, component: COMPONENT.BRACKET },
    { phaseCode: 'FNL1', position: 16, type: ITEM_POSITION.BOTTOM, component: COMPONENT.BRACKET },



    { phaseCode: 'FNL2', position: 1, type: ITEM_POSITION.TOP, component: COMPONENT.BRACKET },
    { phaseCode: 'FNL2', position: 2, type: ITEM_POSITION.BOTTOM, component: COMPONENT.BRACKET },
    { phaseCode: 'FNL2', position: 3, type: ITEM_POSITION.TOP, component: COMPONENT.BRACKET },
    { phaseCode: 'FNL2', position: 4, type: ITEM_POSITION.BOTTOM, component: COMPONENT.BRACKET },
    { phaseCode: 'FNL2', position: 5, type: ITEM_POSITION.TOP, component: COMPONENT.BRACKET },
    { phaseCode: 'FNL2', position: 6, type: ITEM_POSITION.BOTTOM, component: COMPONENT.BRACKET },
    { phaseCode: 'FNL2', position: 7, type: ITEM_POSITION.TOP, component: COMPONENT.BRACKET },
    { phaseCode: 'FNL2', position: 8, type: ITEM_POSITION.BOTTOM, component: COMPONENT.BRACKET },



    { phaseCode: 'FNL', position: 1, type: ITEM_POSITION.TOP, component: COMPONENT.BRACKET },
    { phaseCode: 'FNL', position: 2, type: ITEM_POSITION.BOTTOM, component: COMPONENT.BRACKET },
    { phaseCode: 'FNL', position: 3, type: ITEM_POSITION.TOP, component: COMPONENT.BRACKET },
    { phaseCode: 'FNL', position: 4, type: ITEM_POSITION.BOTTOM, component: COMPONENT.BRACKET },

    { phaseCode: 'SFNL', position: 1, type: ITEM_POSITION.TOP, component: COMPONENT.BRACKET },
    { phaseCode: 'SFNL', position: 2, type: ITEM_POSITION.BOTTOM, component: COMPONENT.BRACKET },


    { phaseCode: 'SFNL1', position: 2, type: ITEM_POSITION.TOP, component: COMPONENT.BRACKET },
    { phaseCode: 'SFNL1', position: 2, type: ITEM_POSITION.CENTER, component: COMPONENT.BRACKET },
    { phaseCode: 'SFNL1', position: 2, type: ITEM_POSITION.BOTTOM, component: COMPONENT.BRACKET },



  ]



  return data

}

